import React, { Component } from 'react';
import { Field, change } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import checkboxFase from '../common/form/checkboxFase';
import If from '../common/operator/if';

class FaseConflitoControlador extends Component {
  constructor(props) {
    super(props);
    this.geralFasesConflito = this.geralFasesConflito.bind(this);
  }

  componentDidMount() {
    // Inicializar valores dos checkboxes a partir dos dados do anel
    if (this.props.atualizarDoAnel && this.props.aneis && this.props.aneis[this.props.anelSelecionado]) {
      const anel = this.props.aneis[this.props.anelSelecionado];
      const fasesIni = parseInt(this.props.numeroFasesIni) + 1;
      const fasesFin = this.props.numeroFases;

      for (let idxFase = fasesIni; idxFase <= fasesFin; idxFase++) {
        for (let idx = fasesIni; idx <= idxFase; idx++) {
          const fieldName = `fase${idx - 1}_fase${idxFase}`;
          if (anel[fieldName] !== undefined) {
            // Atualizar o valor no redux-form
            this.props.change('controladorForm', fieldName, anel[fieldName]);
          }
        }
      }
    }
  }

  componentDidUpdate(prevProps) {
    // Atualizar valores quando o anel selecionado mudar
    if (
      this.props.atualizarDoAnel &&
      (prevProps.anelSelecionado !== this.props.anelSelecionado ||
        prevProps.numeroFases !== this.props.numeroFases ||
        prevProps.numeroFasesIni !== this.props.numeroFasesIni)
    ) {
      const anel = this.props.aneis[this.props.anelSelecionado];
      const fasesIni = parseInt(this.props.numeroFasesIni) + 1;
      const fasesFin = this.props.numeroFases;

      for (let idxFase = fasesIni; idxFase <= fasesFin; idxFase++) {
        for (let idx = fasesIni; idx <= idxFase; idx++) {
          const fieldName = `fase${idx - 1}_fase${idxFase}`;
          if (anel[fieldName] !== undefined) {
            // Atualizar o valor no redux-form
            this.props.change('controladorForm', fieldName, anel[fieldName]);
          }
        }
      }
    }
  }

  geralFasesConflito() {
    let faseGrupoObj = [];
    let fasesIni = parseInt(this.props.numeroFasesIni) + 1;
    let fasesFin = this.props.numeroFases;

    for (let idxFase = fasesIni; idxFase <= fasesFin; idxFase++) {
      let faseObj = [];
      for (let idx = fasesIni; idx <= idxFase; idx++) {
        const fieldName = `fase${idx - 1}_fase${idxFase}`;

        // Sempre use o mesmo formato de Field, mantenha a simplicidade
        faseObj.push(
          <Field
            name={fieldName}
            key={fieldName}
            component={checkboxFase}
            label={`F${idx - 1} c/ F${idxFase}`}
            type="checkbox"
            disabled={this.props.disabled}
            onChange={(event, newValue) => {
              // Se atualizarDoAnel estiver habilitado, atualiza o valor no anel
              if (this.props.atualizarDoAnel && this.props.aneis && this.props.aneis[this.props.anelSelecionado]) {
                this.props.aneis[this.props.anelSelecionado][fieldName] = newValue;
              }
            }}
          />,
        );
      }
      faseGrupoObj.push(<div key={`fase${idxFase}`}>{faseObj}</div>);
    }

    return faseGrupoObj;
  }

  render() {
    return (
      <div>
        <div className="form-group form-group-sm">
          <label className="label-gt" htmlFor="fase1_fase2">
            Fases não conflitantes:
          </label>
        </div>
        {this.geralFasesConflito()}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({ change }, dispatch);
export default connect(
  null,
  mapDispatchToProps,
)(FaseConflitoControlador);
